// Module
var code = "<input type=\"date\" ng-model=\"workflowItem.Value\" ng-disabled=\"workflowItem.Status !== 'Active' || !stateController.checkRole(workflowItem.EffectiveRole)\" ng-change=\"stateController.onClickSubmit(workflowItem)\" class=\"form-select form-select-sm\" style=\"float:right;margin-right:20px\"/> ";
// Exports
export default code;